import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster, toast } from "sonner";
import "@/App.css";
import { translations } from "@/i18n";
import { LangContext, scrollToId } from "@/lang";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import BookingForm from "@/components/BookingForm";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/components/AuthCallback";
import Admin from "@/components/Admin";
import Tarifs from "@/components/Tarifs";
import Merci from "@/components/Merci";

function App() {
  const [lang, setLang] = useState("fr");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "cancel") {
      toast.error(t.booking?.paymentCancelled);
      window.history.replaceState({}, "", window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div className="bg-obsidian text-ivory min-h-screen font-sans antialiased">
        <div className="grain-overlay" />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid rgba(154,123,36,0.35)", color: "#191B22" } }} />
      </div>
    </LangContext.Provider>
  );
}

function Landing() {
  useEffect(() => {
    const target = sessionStorage.getItem("scrollTo");
    if (target) {
      sessionStorage.removeItem("scrollTo");
      setTimeout(() => scrollToId(target), 600);
    }
  }, []);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BookingForm />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/tarifs" element={<Tarifs />} />
      <Route path="/merci" element={<Merci />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default App;
